import React, { useEffect, Fragment, useCallback } from 'react';
import PropTypes from 'prop-types';
import { reaction } from 'mobx';
import { observer } from 'mobx-react';

import { translate } from 'services/i18nService';
import FanClubStore from 'stores/FanClubStore';
import MyShopStore from 'stores/MyShopStore';
import ProfileStore from 'stores/ProfileStore';
import MyShopItem from 'components/MyShopItem/MyShopItem';
import Pod from 'components/Pod/Pod';
import { MY_LIBRARY_FILTERS } from 'enum/helpers';
import { generateID } from 'utils/helpers';

import GalleryStore from '../../../ProfileV2Mobile/MobileGallery/GalleryStore';
import GalleryThumbnail from '../../../ProfileV2Mobile/MobileGallery/GalleryThumbnail';

import LatestContentStore from './LatestContentStore';
import styles from './LatestContent.css';


const IDS = {
  prefix: 'tsIQXJDx',
  element: 'LatestContent',
  item: 'item',
};

const makeId = generateID(IDS.prefix, IDS.element);

const LatestContent = (props) => {
  const { getGalleries } = GalleryStore;
  const { profileName, showRegistrationModal } = ProfileStore;
  const { isFan } = FanClubStore;
  const { getPerformerVideos, hasAccess } = MyShopStore;
  const { latestContent, isLatestContentVisible, latestContendIsLoading } = LatestContentStore;
  const { user } = props;

  const isMyProfile = user.username && profileName.toLowerCase() === user.username.toLowerCase();

  useEffect(() => {
    getGalleries(profileName);
  }, [getGalleries, profileName]);

  useEffect(() => {
    getPerformerVideos(profileName, MY_LIBRARY_FILTERS.MOST_RECENT);
  }, [profileName, isFan, getPerformerVideos]);

  useEffect(
    () =>
      reaction(
        () => MyShopStore.videoPurchased,
        (videoPurchased) => {
          if (videoPurchased) {
            getGalleries(profileName);
            getPerformerVideos(profileName, MY_LIBRARY_FILTERS.MOST_RECENT);
          }
        }
      ),
    [getGalleries, getPerformerVideos, profileName]
  );

  const handleLike = useCallback((item) => {
    if (hasAccess(item)) {
      if (!item.liked) {
        MyShopStore.likeVideo(item.videoId);
      } else {
        MyShopStore.unlikeVideo(item.videoId);
      }
    }
  }, [hasAccess]);

  const podStyle = { marginBottom: '30px' };

  return isLatestContentVisible ? (
    <Pod
      loading={latestContendIsLoading}
      style={podStyle}
      title={translate('v2profile.latest.content')}
    >
      <div className={styles.wrapper}>
        {latestContent.map((item, index) => (
          <Fragment key={item.galleryId ? item.galleryId : item.videoId}>
            {item.galleryId ? (
              <div className={styles.latestItem} id={`${makeId(IDS.item)}-${index + 1}`}>
                <GalleryThumbnail gallery={item} user={user} />
              </div>
            ) : (
              <div className={styles.latestItemVideo} id={`${makeId(IDS.item)}-${index + 1}`}>
                <MyShopItem
                  handleLike={handleLike}
                  hasAccess={hasAccess(item) || isMyProfile}
                  item={item}
                  setShowRegistrationModal={showRegistrationModal}
                  user={user}
                />
              </div>
            )}
          </Fragment>
        ))}
      </div>
    </Pod>
  ) : null;
};

LatestContent.propTypes = { user: PropTypes.object.isRequired };

export default observer(LatestContent);
